import HomeSlider from "../Assets/Imgs/home_slider_1.webp";
import Logo from "../Assets/Imgs/nlp_logo.png";
import AppLogo from "../Assets/Imgs/App_logo2.png";
// import AppLogo2 from "../Assets/Imgs/App_logo2.png";
import ApplyLegelIcon from "../Assets/Imgs/apply_legal.png";
import LegelDisputesIcon from "../Assets/Imgs/legal_disputes.png";
import RegisterBusinessIcon from "../Assets/Imgs/register_business.png";
import ProtectBusinessIcon from "../Assets/Imgs/protect_business.png";
import OnlineDocumentation from "../Assets/Imgs/online_documentation.png";
import FileTaxIcon from "../Assets/Imgs/file_tax.png";
import FileCaseIcon from "../Assets/Imgs/file_case.png";
import TalkToLawyerIcon from "../Assets/Imgs/assigned-professional.png";
import APSIcon from "../Assets/Imgs/why_us_1.png";
import DENIcon from "../Assets/Imgs/why_us_2.png";
import EasyToUseIcon from "../Assets/Imgs/why_us_3.png";
import QCSIcon from "../Assets/Imgs/why_us_4.png";
import ReviewIcon from "../Assets/Imgs/review_img_1.png";
import OyoIcon from "../Assets/Imgs/partner_1.png";
import SwiggyIcon from "../Assets/Imgs/partner_2.png";
import BigBasketIcon from "../Assets/Imgs/partner_3.png";
import HDFCIcon from "../Assets/Imgs/partner_4.png";
import AmazonIcon from "../Assets/Imgs/partner_5.png";
import ActiveOrdersIcon from "../Assets/Imgs/active-order.png";
import MediationIcon from "../Assets/Imgs/medation.png";
import ConsultationIcon from "../Assets/Imgs/consulation.png";
import TPLFIcon from "../Assets/Imgs/tplf.png";
import ConsulIcon from "../Assets/Imgs/consul-order.png";
import ComplainOrderIcon from "../Assets/Imgs/complain-order.png";
import TaxOrderIcon from "../Assets/Imgs/tax-order.png";
import DocumentationIcon from "../Assets/Imgs/documentation-order.png";
import EarnAndPayIcon from "../Assets/Imgs/earn-payment.png";
import ContactUsIcon from "../Assets/Imgs/contact.png";
import OtherOrderIcon from "../Assets/Imgs/other-order.png";
import ApplicationCalIcon from "../Assets/Imgs/application-calendar.png";
import KnowledgeBankIcon from "../Assets/Imgs/knowledge-bank.png";
import FBIcon from "../Assets/Imgs/fb.png";
import InstaIcon from "../Assets/Imgs/insta.png";
import DashboardIcon from "../Assets/Imgs/dashboard.svg";
import WhatsAppIcon from "../Assets/Imgs/whatsapp.png";
import RaiseComplaintIcon from "../Assets/Imgs/raise.svg";
import HistoryIcon from "../Assets/Imgs/history.svg";
import ProfileIcon from "../Assets/Imgs/profile.svg";
import SettingsIcon from "../Assets/Imgs/setting.svg";
import PaymentIcon from "../Assets/Imgs/payment.svg";
import AssignProfessionalIcon from "../Assets/Imgs/assigned-professional.png";
import ChartedAccountentIcon from "../Assets/Imgs/financial-overview.png";
import TalkToLaywerIcon from "../Assets/Imgs/assigned-professional.png";
import FileACaseIcon from "../Assets/Imgs/file-a-case-g.png";
import PrivateLimitedIcon from "../Assets/Imgs/platform-overview.png";
import LLPOrdersIcon from "../Assets/Imgs/drafting-v.png";
import ArbritratioIcon from "../Assets/Imgs/tax-order-y.png";
import AssignCompanyIcon from "../Assets/Imgs/assigned-company.png";
import NotificationIcon from "../Assets/Imgs/notification.svg";
import { CheckBoxOutlineBlank as CheckBoxIcon } from "@mui/icons-material";
import { Check as checkIcon } from "@mui/icons-material";
import { Logout as LogoutIcon } from "@mui/icons-material";
import { Restore as RestoreIcon } from "@mui/icons-material";
import { ArrowDropUp } from "@mui/icons-material";
import { ArrowDropDown } from "@mui/icons-material";
import { Search as SearchIcon } from "@mui/icons-material";
import {
  TaskAltRounded as TaskAltRoundedIcon,
  ReplayRounded as ReplayRoundedIcon,
  CalendarMonth as CalenderIcon,
} from "@mui/icons-material";
// import {ReplayRounded as ReplayRoundedIcon} from "@mui/icons-material/ReplayRounded";
import {
  LockRounded as LockIcon,
  Call as CallIcon,
  Close as CloseIcon,
  NoteAdd as CaseCreationIcon,
} from "@mui/icons-material";

const ImgPath = {
  HomeSlider,
  SearchIcon,
  CaseCreationIcon,
  LockIcon,
  CloseIcon,
  // AppLogo,
  AppLogo,
  CallIcon,
  TaskAltRoundedIcon,
  ReplayRoundedIcon,
  CalenderIcon,
  // Logo,
  ApplyLegelIcon,
  LegelDisputesIcon,
  ActiveOrdersIcon,
  TPLFIcon,
  ConsulIcon,
  ConsultationIcon,
  RestoreIcon,
  ArrowDropDown,
  ComplainOrderIcon,
  TaxOrderIcon,
  DocumentationIcon,
  EarnAndPayIcon,
  ApplicationCalIcon,
  ContactUsIcon,
  OtherOrderIcon,
  MediationIcon,
  RegisterBusinessIcon,
  ProtectBusinessIcon,
  OnlineDocumentation,
  FileTaxIcon,
  FileCaseIcon,
  TalkToLawyerIcon,
  APSIcon,
  DENIcon,
  EasyToUseIcon,
  ReviewIcon,
  QCSIcon,
  OyoIcon,
  SwiggyIcon,
  BigBasketIcon,
  HDFCIcon,
  AmazonIcon,
  FBIcon,
  InstaIcon,
  WhatsAppIcon,
  CheckBoxIcon,
  checkIcon,
  LogoutIcon,
  ArrowDropUp,
  DashboardIcon,
  RaiseComplaintIcon,
  ProfileIcon,
  HistoryIcon,
  PaymentIcon,
  NotificationIcon,
  SettingsIcon,
  KnowledgeBankIcon,
  AssignProfessionalIcon,
  ChartedAccountentIcon,
  ArbritratioIcon,
  AssignCompanyIcon,
  TalkToLaywerIcon,
  FileACaseIcon,
  PrivateLimitedIcon,
  LLPOrdersIcon,
};

export default ImgPath;
